import {doc, getDoc} from "@firebase/firestore";
import {firestore} from "@/services/firebase.service";

// This function really should only be temporary while we figure out what the underlying issue is. We have users
// reporting that their game stats are getting overwritten with a blanks state while logged in, essentially overwriting
// their game state. To counteract that we put an emergency check in the set function that does an extra fetch of the
// game stats remotely and makes sure that we're not overwriting it with a smaller (or blank) state.
export const gameStatEmergencyError = async (collection: string, userId: string, newData: Record<string, any>) => {
  const hasSpellifyGameStats = 'spellifyGameStats' in newData
  const hasSpellifyGameStatsHard = 'spellifyGameStatsHard' in newData
  const hasCrosswordTimes = 'crosswordTimes' in newData
  if (!hasSpellifyGameStats && !hasSpellifyGameStatsHard && !hasCrosswordTimes) return
  console.log(newData)
  const ref = doc(firestore, collection, userId)
  const snapshot = await getDoc(ref)
  if (snapshot.exists()) {
    const remoteData = snapshot.data() as Record<string, any>
    // Check if the new data has fewer wins than the remote data
    if (hasSpellifyGameStats && remoteData.spellifyGameStats && !newData.spellifyGameStats) {
      return 'Detected attempt to overwrite Spellify stats with blank state. Aborting to prevent data loss. Please contact support.'
    }
    if (
      newData.spellifyGameStats &&
      remoteData.spellifyGameStats &&
      JSON.parse(remoteData.spellifyGameStats) &&
      JSON.parse(remoteData.spellifyGameStats).gamesPlayed > newData.spellifyGameStats.gamesPlayed
    ) {
      return 'Detected attempt to overwrite Spellify stats with fewer games played. Aborting to prevent data loss. Please contact support.'
    }
    if (hasSpellifyGameStatsHard && remoteData.spellifyGameStatsHard && !newData.spellifyGameStatsHard) {
      return 'Detected attempt to overwrite Spellify Hard stats with blank state. Aborting to prevent data loss. Please contact support.'
    }
    if (
      newData.spellifyGameStatsHard &&
      remoteData.spellifyGameStatsHard &&
      JSON.parse(remoteData.spellifyGameStatsHard) &&
      JSON.parse(remoteData.spellifyGameStatsHard).gamesPlayed > newData.spellifyGameStatsHard.gamesPlayed
    ) {
      return 'Detected attempt to overwrite Spellify Hard stats with fewer games played. Aborting to prevent data loss. Please contact support.'
    }
    if (hasCrosswordTimes && remoteData.crosswordTimes && !newData.crosswordTimes) {
      return 'Detected attempt to overwrite Crossword times with blank state. Aborting to prevent data loss. Please contact support.'
    }
    if (
      newData.crosswordTimes &&
      remoteData.crosswordTimes &&
      JSON.parse(remoteData.crosswordTimes) &&
      Object.keys(JSON.parse(remoteData.crosswordTimes)).length > Object.keys(newData.crosswordTimes).length
    ) {
      return 'Detected attempt to overwrite Crossword times with fewer entries. Aborting to prevent data loss. Please contact support.'
    }
  }
  return ''
}